export default __webpack_public_path__ + "478f68f9eda634bcbb07464849bdbfeb.woff2";